import { Paginator } from '@upsales/components';

window.Paginator = Paginator;
export default Paginator;
